/**
 * APIルーター定数クラス
 * アプリケーション全体で使用されるAPIエンドポイントのURLを定義する
 */
import RouterConstants from "@/common/constants/app.constants";

export default class ApiRouterConstants {
  /** LINE CRMキャンペーンAPI */
  static API_CAMPAIGNS = `${RouterConstants.API_URL}line_crm/campaigns`;

  /** LINE CRMキャンペーンセグメントAPI */
  static API_CAMPAIGN_SEGMENTS = `${RouterConstants.API_URL}line_crm/segments/categories`;

  /** LINE CRMキャンペーンセグメントカテゴリAPI */
  static API_CAMPAIGN_SEGMENTS_CATEGORIES = `${RouterConstants.API_URL}line_crm/segments/`;

  /** クリニック基本情報API */
  static API_CLINICS = `${RouterConstants.API_URL}api/v1/clinics`;

  /** クライアント情報API */
  static API_CLIENT = `${RouterConstants.API_URL}api/v1/clinics/client`;

  /** お問い合わせAPI */
  static API_CONTACT = `${RouterConstants.API_URL}api/v1/clinics/contacts`;

  /** サインインAPI */
  static API_SIGN_IN = `${RouterConstants.API_URL}api/v1/clinics/sign_in`;

  /** パスワードリセットAPI */
  static API_FORGOT_PASSWORD = `${RouterConstants.API_URL}api/v1/clinics/password`;

  /** 郵便番号検索API */
  static API_ZIPCODES = `${RouterConstants.API_URL}api/v1/clinics/zipcodes`;

  /** 顧客管理API */
  static API_CUSTOMERS = `${RouterConstants.API_URL}api/v1/clinics/customers`;

  /** ホットペッパー顧客API */
  static API_HOTPEPPER_CUSTOMERS = `${RouterConstants.API_URL}api/v1/clinics/hotpeppers/customers`;

  /** リッチメニューテンプレートAPI */
  static API_RICH_MENU_TEMPLATES = `${RouterConstants.API_URL}api/v1/clinics/lines/menu_templates`;

  /** リッチメニューAPI */
  static API_RICH_MENUS = `${RouterConstants.API_URL}api/v1/clinics/lines/rich_menus`;

  /** スケジュールメッセージAPI */
  static API_SCHEDULED_MESSAGES = `${RouterConstants.API_URL}line_crm/scheduled_messages`;

  /** LINEアカウントAPI */
  static API_ACCOUNTS = `${RouterConstants.API_URL}api/v1/clinics/lines/accounts`;

  /** 未連携アカウントAPI */
  static API_UNLINKED_ACCOUNTS = `${this.API_ACCOUNTS}/unlinked`;

  /** ライブチャットメッセージAPI */
  static API_LIVE_CHAT_MESSAGES = `${RouterConstants.API_URL}api/v1/clinics/lines/live_chat_messages`;

  /** スタッフ管理API */
  static API_STAFFS = `${RouterConstants.API_URL}api/v1/clinics/staffs`;

  /** メニュー管理API */
  static API_MENUS = `${RouterConstants.API_URL}api/v1/clinics/medical_menus`;

  /** オプションメニューAPI */
  static API_OPTIONS = `${RouterConstants.API_URL}api/v1/clinics/medical_options`;

  /** タグ管理API */
  static API_TAGS = `${ApiRouterConstants.API_CLINICS}/tags`;

  /** クリニック営業日設定API */
  static API_CLINIC_ROUTINE = `${ApiRouterConstants.API_CLINICS}/clinic_business_day_setting`;

  /** 前月適用API */
  static API_APPLY_PREV_MONTH = `${ApiRouterConstants.API_CLINICS}/clinic_business_day_setting/apply_prev_month`;

  /** 予約設定API */
  static API_BOOKING_SETTING = `${ApiRouterConstants.API_CLINICS}/clinic_booking_settings`;

  /** 予約管理API */
  static API_BOOKINGS = `${this.API_CLINICS}/bookings`;

  /** 予約リクエストAPI */
  static API_REQUEST_BOOKINGS = `${this.API_CLINICS}/request_bookings`;

  /** スタッフシフト設定API */
  static API_STAFF_SHIFT = `${ApiRouterConstants.API_CLINICS}/clinic_staff_shift`;

  /** スタッフシフト前月適用API */
  static API_STAFF_SHIFT_APPLY_PREV_MONTH = `${ApiRouterConstants.API_CLINICS}/clinic_staff_shift/apply_prev_month`;

  /** スタッフシフト管理API */
  static API_STAFF_SHIFTS = `${ApiRouterConstants.API_CLINICS}/clinic_staff_shifts`;

  /** 空き時間スロットAPI */
  static API_SLOTS_FREE = `${RouterConstants.API_URL}api/v1/clinics/bookings/slots_free`;

  /** メディカルメニューカテゴリAPI */
  static API_MEDICAL_MENU_CATEGORIES = `${RouterConstants.API_URL}api/v1/clinics/medical_menu_categories`;

  /** タグカテゴリAPI */
  static API_TAG_CATEGORIES = `${RouterConstants.API_URL}api/v1/clinics/tag_categories`;

  /** ライブメッセージテンプレートAPI */
  static API_LIVE_MESSAGE_TEMPLATES = `${RouterConstants.API_URL}api/v1/clinics/live_message_templates`;

  /** 配信グループAPI */
  static API_DISTRIBUTION_GROUPS = `${RouterConstants.API_URL}line_crm/distribution_groups`;

  /** 手動タグAPI */
  static API_MANUAL_TAGS = `${RouterConstants.API_URL}api/v1/clinics/manual_tags`;

  /** クライアント詳細API */
  static API_CLIENT_DETAILS = `${RouterConstants.API_URL}api/v1/clinics/client_details`;

  /** 予約顧客API */
  static API_BOOKING_CUSTOMERS = `${RouterConstants.API_URL}api/v1/clinics/bookings/customers`;

  /** 予約メニューAPI */
  static API_BOOKING_MENUS = `${RouterConstants.API_URL}api/v1/clinics/bookings/medical_menus`;

  /** LINE通知メッセージAPI */
  static API_LINE_NOTIFICATION_MESSAGES = `${RouterConstants.API_URL}api/v1/clinics/line_notification_messages`;

  /** サービスタグAPI */
  static API_SERVICE_TAGS = `${RouterConstants.API_URL}api/v1/clinics/service_tags`;

  /** 予約通知API */
  static API_BOOKING_NOTIFICATIONS = `${RouterConstants.API_URL}api/v1/clinics/booking_notifications`;

  /** スタッフ優先度API */
  static API_STAFF_PRIORITIES = `${RouterConstants.API_URL}api/v1/clinics/staffs/priorities`;

  /** 部屋・設備管理API */
  static API_ROOMS = `${RouterConstants.API_URL}api/v1/clinics/rooms`;

  /** 重複顧客API */
  static API_DUPLICATE_CUSTOMERS = `${RouterConstants.API_URL}api/v1/clinics/customers/duplicates`;
}
